<template>
	<div id="Gsjj">
		<div class="left">

			<h4 class="animate__animated animate__fadeInLeft">Hydrogroup Technology Co., Ltd</h4>
			<h2 class="animate__animated animate__fadeInLeft">海卓水信</h2>
			<!-- <img src="../../assets/img/left.png" style="width:758px; height: 817px;"> -->
			<a class="music animate__animated animate__fadeInUp" @click="playerMusic">
				<span class="yuan1"></span>
				<span class="yuan2"></span>
				<span class="yinpin"></span>
				<p></p>
			</a>
			<audio id="resource" ref="up" :src="mp3src" controls style="display:none;"></audio>
		</div>
		<div class="right">
			<!-- <img src="../../assets/img/right.png" style="width:1280px; height: 817px;"> -->
			<div class="logo ">
				<img src="../../assets/img/logo.png" class="contactInfo animate__animated animate__fadeInRight" />
				<h2 class="animate__animated animate__fadeInRight">
					海卓水信科技有限公司由清华大学水利系教师团队于2009年创立。10多年来一直从事气象、遥感及水利水文领域的数据利用及应用开发。多年来公司服务了水利部、中石油、国家电网、智慧城市等国家级大型客户的信息化建设项目建设。
				</h2>
				<div class="contactInfo animate__animated animate__fadeInRight">
					<div class="card">
						<h3>北京海卓水信</h3>
						<p>联系人：张春雨</p>
						<p>zhangchunyu@hydrogroup.com.cn</p>
						<p>北京市海淀区西四环北路160号</p>
					</div>
					<div class="card">
						<h3>天津海卓水信</h3>
						<p>联系人：贺梦杰</p>
						<p>hemengjie@hydrogroup.com.cn</p>
						<p>天津市西青区印力中心写字楼</p>
					</div>
					<div class="card">
						<h3>四川海卓水信</h3>
						<p>联系人：杜伟</p>
						<p>duwei@hydrogroup.com.cn</p>
						<p>成都市锦江区琉璃路8号</p>
					</div>
					<div class="card">
						<h3>北京海卓水信（深圳办事处）</h3>
						<p>联系人：余伟</p>
						<p>yuwei@hydrogroup.com.cn</p>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				mp3src: require('@/assets/mp3/20220801_173326.mp3')
			}
		},
		methods: {
			jumpTo(param) {
				this.$emit('mainData', param)
			},
			playerMusic() {
				// var dom = this.$refs.up
				// dom.play()
			}
		}
	}
</script>

<style scoped="scoped">
	@font-face {
		font-family: "HYDaHeiJ";
		src: url("../../assets/font/HYDaHeiJ.ttf");
	}

	@font-face {
		font-family: "PingFang-SC-Semibold-2";
		src: url("../../assets/font/PingFang-SC-Semibold-2.ttf");
	}

	#Gsjj {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 0;
		margin: 0;
		overflow: hidden;
	}

	#Gsjj .left h4 {
		width: 200px;
		height: 34px;
		font-size: 12px;
		font-family: PingFang-SC-Semibold-2;
		font-weight: 400;
		margin-left: 80px;
		margin-top: 440px;
		color: #FFFFFF;
		text-align: left;
	}

	#Gsjj .left h2 {
		width: 321px;
		height: 100px;
		font-size: 36px;
		font-family: PingFang-SC-Semibold-2;
		font-weight: 600;
		color: #FFFFFF;
		margin-left: 80px;
		text-align: left;
	}

	#Gsjj .left {
		position: absolute;
		left: 0;
		width: 758px;
		height: 817px;
		background: url(../../assets/img/left.png);
		background-size: 100% 100%;
		/* background: linear-gradient(180deg, rgba(144, 158, 255, 0.200) 0%, rgba(83, 59, 219, 0.4) 100%); */
		opacity: 1;
		/* border: 1px solid #897BD1; */
		filter: blur(undefinedpx);
	}

	@media screen and (max-width:2561px) {
		#Gsjj .left {
			width: 1058px;
			height: 1320px;
		}
	}

	@media screen and (max-width:1921px) {
		#Gsjj .left {
			width: 558px;
			height: 960px;
		}
	}

	@media screen and (max-width:1281px) {
		#Gsjj .left {
			width: 480px;
			height: 904px;
		}
	}

	#Gsjj .right {
		position: absolute;
		right: 0px;
		width: 1480px;
		height: 817px;
		background: url(../../assets/img/right.png);
		background-size: 100% 100%;
		opacity: 1;
		margin-left: -20px;

	}

	@media screen and (max-width:2561px) {
		#Gsjj .right {
			width: 1680px;
			height: 1320px;
		}
	}

	@media screen and (max-width:1921px) {
		#Gsjj .right {
			width: 1280px;
			height: 960px;
		}
	}

	@media screen and (max-width:1281px) {
		#Gsjj .right {
			width: 920px;
			height: 904px;
		}
	}

	#Gsjj .right h2 {
		width: 1000px;
		height: 80px;
		font-size: 14px;
		font-family: PingFang-SC-Semibold-2;
		font-weight: 600;
		color: #9BA1BF;
		line-height: 30px;
		text-align: left;
		border-bottom: 4px rgba(255,255,255,0.23) solid;
	}

	.close {
		position: absolute;
		left: 80px;
		top: 324px;
		cursor: pointer;
	}

	#Gsjj .left .music {
		display: block;
		position: relative;
		margin-left: 80px;
		margin-top: 60px;
		width: 102px;
		height: 102px;
	}

	#Gsjj .left .music .yuan1 {
		position: absolute;
		top: 0;
		display: block;
		width: 102px;
		height: 102px;
		/* background: url(../../assets/img/yuan2.png); */
		background-repeat: no-repeat;
		background-size: 100% 100%;
		text-decoration: none;
		color: #fff;
		padding: 9px;
		cursor: pointer;
		border-radius: 50%;
		background: #3f8ebc;
		animation: twinkling 1s infinite ease-in-out;
		animation-fill-mode: both;
	}

	#Gsjj .left .music .yuan2 {
		position: absolute;
		left: 9px;
		top: 9px;
		display: block;
		width: 72px;
		height: 72px;
		background: #2f8eb1;
		background-repeat: no-repeat;
		/*    background-size: 100% 100%; */
		padding: 15px;
		cursor: pointer;
		border-radius: 50%;
	}

	#Gsjj .left .music .yinpin {
		position: absolute;
		left: 24px;
		top: 24px;
		display: block;
		width: 72px;
		height: 72px;
		background: url(../../assets/img/yinpin.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		cursor: pointer;
		border-radius: 50%;
	}

	#Gsjj .left .music .yuan2:before {
		content: '';
		display: block;
		width: 72px;
		height: 72px;
		border-radius: 50%;
		position: absolute;
		left: 0;
		top: 0;
		opacity: .4;
		padding: 15px;
		background-color: #2f8eb1;
		border-radius: 50%;
		animation: scale 1s infinite cubic-bezier(0, 0, .49, 1.02);
	}

	#Gsjj .left .music p {
		position: absolute;
		left: 90px;
		top: 50px;
		width: 200px;
		color: #fff;
		cursor: pointer;
		text-transform: capitalize;
	}

	@keyframes twinkling {
		0% {
			opacity: 0.2;
			transform: scale(1);
		}

		50% {
			opacity: 0.5;
			transform: scale(1.12);
		}

		100% {
			opacity: 0.2;
			transform: scale(1);
		}
	}

	@keyframes scale {
		0% {
			transform: scale(1)
		}

		50%,
		75% {
			transform: scale(1.2)
		}

		78%,
		100% {
			opacity: 0
		}
	}

	.left {
		z-index: 1;
	}

	.logo {
		position: absolute;
		/* 相对于父元素（.right）定位 */
		top: 40%;
		/* 垂直方向中心 */
		left: 50%;
		/* 水平方向中心 */
		transform: translate(-50%, -50%);
		/* 将自身移动到中心位置 */
		text-align: center;
		z-index: 999;
		/* 确保logo在最上层 */
	}

	.logo img {
		display: block;
		margin: 0 auto;
	}

	.logo h2 {
		margin-top: 20px;
		color: #fff;
		font-size: 18px;
		line-height: 1.5;
		text-align: center;
		width: 80%;
		/* 控制文字宽度以适配居中 */
	}
	.contactInfo {
		display: flex;
		justify-content: space-between;
		margin-top: 100px;
		padding: 0 20px;
		gap: 20px;
	}

	.contactInfo .card {
		flex: 1;
		padding: 20px;
		background: rgba(255, 255, 255, 0.05);
		backdrop-filter: blur(10px);
		border-radius: 8px;
		text-align: left;
		transition: all 0.3s ease;
	}

	.contactInfo .card:hover {
		transform: translateY(-5px);
		background: rgba(255, 255, 255, 0.1);
	}

	.contactInfo .card h3 {
		color: #FFFFFF;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.contactInfo .card p {
		color: #9BA1BF;
		font-size: 14px;
		line-height: 1.8;
		margin: 5px 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/Gsjj.vue